var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBookActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 16C1.98611 16 1.33681 15.7326 0.802083 15.1979C0.267361 14.6632 0 14.0139 0 13.25V2.77083C0 2.00556 0.267361 1.35243 0.802083 0.811459C1.33681 0.270486 1.98611 0 2.75 0H12V12C11.6389 12 11.3403 12.1215 11.1042 12.3646C10.8681 12.6076 10.75 12.9028 10.75 13.25C10.75 13.6111 10.8681 13.9132 11.1042 14.1562C11.3403 14.3993 11.6389 14.5208 12 14.5208V16H2.75ZM3.22917 9H4.25L4.78583 7.47917H7.20833L7.74333 9H8.79167L6.54083 3H5.47917L3.22917 9ZM5.10417 6.60417L5.97917 4.125H6.02083L6.89583 6.60417H5.10417ZM2.75 14.5H9.54167C9.44444 14.3056 9.37153 14.1111 9.32292 13.9167C9.27431 13.7222 9.25 13.5051 9.25 13.2652C9.25 13.0395 9.27778 12.8208 9.33333 12.6092C9.38889 12.3975 9.46528 12.1944 9.5625 12H2.75C2.38889 12 2.09028 12.1215 1.85417 12.3646C1.61806 12.6076 1.5 12.9028 1.5 13.25C1.5 13.6111 1.61806 13.9097 1.85417 14.1458C2.09028 14.3819 2.38889 14.5 2.75 14.5Z",
    fill: "#5F11EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookActive);
export default __webpack_public_path__ + "static/media/icon-book-active.0f6524e56c11717d730eb0d791bcf3bf.svg";
export { ForwardRef as ReactComponent };